'use strict'

import client from "@helpers/client";

export const clientPlugin = (store) => {
    // called when the store is initialized
    store.client = client;
}